export const rawProjects = [
  {
    id: 'la-poste-outdoor',
    slug: 'la-poste-outdoor',
    title: 'La Poste Outdoor WebAR',
    client: 'La Poste',
    city: 'Paris',
    summary:
      "Plateforme WebAR mobile-first pour une exposition exterieure composee de scenes imprimees et d'experiences image tracking sans application native.",
    intro:
      "Scanne un QR code, autorise la camera, vise la bache et decouvre le contenu augmente directement dans ton navigateur.",
    siteUrl: 'https://laposte-web-ar.example.com',
    theme: {
      accent: '#ffd100',
      accentSoft: '#fff2a6',
      surface: '#101626'
    },
    scenes: [
      {
        id: 'souvenir-postal',
        slug: 'souvenir-postal',
        title: 'Souvenir Postal',
        teaser:
          "Experience mono-scene de reference avec video plein cadre et flux audio debloque au premier tap.",
        targetIndex: 0,
        targetPreview: '/assets/images/demo-card.png',
        arContent: {
          kind: 'video',
          label: 'Video overlay La Poste',
          src: '/assets/videos/showcase/postal-signal.mp4',
          width: 1,
          height: 0.552,
          position: [0, 0, 0],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          loop: true,
          withAudio: true,
          poster: '/assets/images/demo-card.png'
        },
        fallback: {
          title: 'Impossible de reconnaitre la scene',
          body:
            "Verifie la lumiere, eloigne-toi legerement puis vise l'image complete. Tu peux aussi voir la video hors mode AR.",
          altContentType: 'video',
          altContentSrc: '/assets/videos/showcase/postal-signal.mp4'
        },
        trackingProfile: {
          instruction:
            "Vise la carte de demonstration en entier. Maintiens le telephone stable pendant une seconde.",
          detectionTimeoutMs: 12000,
          lostTrackingGraceMs: 2500,
          guideScale: 1.04
        }
      },
      {
        id: 'rock-raccoon',
        slug: 'rock-raccoon',
        title: 'Rock Raccoon',
        teaser:
          "Scene mono ou multi avec overlay image premium, ideale pour valider le tracking sur grand format imprime.",
        targetIndex: 0,
        targetPreview: '/assets/images/raccoon-target.png',
        arContent: {
          kind: 'image',
          label: 'Overlay image institutionnel',
          src: '/assets/images/replace-target-template.svg',
          width: 1,
          height: 1,
          position: [0, 0, 0.001],
          rotation: [0, 0, 0],
          scale: [1, 1, 1]
        },
        fallback: {
          title: 'Le visuel n’est pas encore detecte',
          body:
            "Passe en plein ecran sur le second ecran ou rapproche-toi jusqu'a voir les details du visuel. Le contenu alternatif reste accessible en dessous.",
          altContentType: 'image',
          altContentSrc: '/assets/images/raccoon-target.png'
        },
        trackingProfile: {
          instruction:
            "Cadre le visuel du raton laveur sans couper le contour circulaire.",
          detectionTimeoutMs: 12000,
          lostTrackingGraceMs: 2500,
          guideScale: 1.03
        }
      },
      {
        id: 'grand-ours',
        slug: 'grand-ours',
        title: 'Grand Ours',
        teaser:
          "Scene multi-marqueurs avec carte 2D ancree sur la bache pour des contenus editoriaux ou institutionnels.",
        targetIndex: 1,
        targetPreview: '/assets/images/bear-target.png',
        arContent: {
          kind: 'html2d',
          label: 'Cartouche editorial AR',
          width: 1,
          height: 0.75,
          position: [0, -0.08, 0.001],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          headline: 'La Poste en scene',
          body:
            "Structure reusable pour afficher un message 2D premium, un court texte et un call-to-action sans application a installer.",
          cta: 'Scanner une autre scene',
          theme: {
            background: '#0f1724',
            foreground: '#f8fbff',
            accent: '#ffd100'
          }
        },
        fallback: {
          title: 'Scene detectable mais contenu AR alternatif disponible',
          body:
            "Si le tracking tarde, ouvre la scene editorialisee en mode classique pour ne pas perdre le visiteur.",
          altContentType: 'link',
          altContentSrc: '/la-poste-outdoor/scenes/grand-ours'
        },
        trackingProfile: {
          instruction:
            "Cadre l'ours avec le violoncelle et evite les reflets directs sur la bache.",
          detectionTimeoutMs: 12000,
          lostTrackingGraceMs: 2500,
          guideScale: 1.03
        }
      }
    ],
    entries: [
      {
        id: 'souvenir-postal-entry',
        slug: 'souvenir-postal',
        projectId: 'la-poste-outdoor',
        title: 'Experience QR mono-scene - Souvenir Postal',
        mode: 'single',
        sceneIds: ['souvenir-postal'],
        mindFile: '/assets/targets/demo-card.mind',
        maxTrack: 1,
        audioPolicy: 'tap-to-unlock',
        introTitle: 'Active la camera pour lancer la scene',
        introBody:
          "Un seul tap permet d'autoriser la camera et de debloquer l'audio. Ensuite, vise la bache imprimee pour lancer la video."
      },
      {
        id: 'rock-raccoon-entry',
        slug: 'rock-raccoon',
        projectId: 'la-poste-outdoor',
        title: 'Experience QR mono-scene - Rock Raccoon',
        mode: 'single',
        sceneIds: ['rock-raccoon'],
        mindFile: '/assets/targets/band.mind',
        maxTrack: 1,
        audioPolicy: 'tap-to-unlock',
        introTitle: 'Scanne la scene Rock Raccoon',
        introBody:
          "Cette entree dediee montre le cas d'un QR code par scene. L'experience charge une seule scene visible pour ce QR."
      },
      {
        id: 'duo-concert-entry',
        slug: 'duo-concert',
        projectId: 'la-poste-outdoor',
        title: 'Experience QR multi-scenes - Duo Concert',
        mode: 'multi',
        sceneIds: ['rock-raccoon', 'grand-ours'],
        mindFile: '/assets/targets/band.mind',
        maxTrack: 1,
        audioPolicy: 'tap-to-unlock',
        introTitle: 'Scanne l’une des deux scenes du duo',
        introBody:
          "Cette entree unique supporte plusieurs images cibles. Le bon contenu se declenche automatiquement selon la scene reconnue."
      }
    ]
  }
] as const;
